import { Card } from "antd";

import { BalanceLabel, BalanceValue, LowBalanceWarning, Section } from "../styles";
import { formatCents } from "../utils";

const AccountBalanceCard = ({ trove }) => (
  <Section>
    <Card>
      <BalanceLabel>Text Message Account Balance</BalanceLabel>
      <BalanceValue>{formatCents(trove.charge_for_sms ? trove.balance_cents : 0)}</BalanceValue>
      {trove.charge_for_sms && trove.balance_cents <= 0 && (
        <LowBalanceWarning>Account balance is low, messaging may be blocked on your account.</LowBalanceWarning>
      )}
    </Card>
  </Section>
);

export default AccountBalanceCard;
